/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : NodeToolbar.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import PropTypes from "prop-types";
import { Box, IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

export default function NodeToolbar({ visible, onDelete }) {
  if (!visible) return null;

  return (
    <Box
      sx={{
        position: "absolute",
        top: -36,
        right: 0,
        display: "flex",
        gap: 0.5,
        background: "#1e1e1e",
        borderRadius: 1,
        p: 0.5,
        zIndex: 20,
      }}
      onMouseDown={(e) => e.stopPropagation()}
      onClick={(e) => e.stopPropagation()}
    >
      <IconButton size="small" onClick={onDelete}>
        <DeleteIcon fontSize="small" sx={{ color: "#ff5f56" }} />
      </IconButton>
    </Box>
  );
}

NodeToolbar.propTypes = {
  visible: PropTypes.bool,
  onDelete: PropTypes.func,
};
